import { ColumnType, ListingHelper } from 'src/app/core/utils/listing.helper';

import { Component, Input, ViewChild } from '@angular/core';
import { StylesSmartTableComponent } from '@brafton/angular-styles-library';
import { IBaseProject, IPagedList } from '@brafton/common-framework-library';

@Component({
  selector: 'shared-organizations-listing',
  templateUrl: './organizations-listing.component.html',
  styleUrls: ['./organizations-listing.component.scss'],
  host: { class: 'organizations-listing' },
})
export class SharedOrganizationListingComponent {
  @Input() organizations!: IPagedList<IBaseProject>;
  @Input() showColumnHeaders = true;

  @Input() get showOwner() {
    return this.columnBuilder.isShown('owner');
  }
  set showOwner(value: boolean) {
    this.columnBuilder.setShown('owner', value);
  }
  @Input() get showStatus() {
    return this.columnBuilder.isShown('status');
  }
  set showStatus(value: boolean) {
    this.columnBuilder.setShown('status', value);
  }

  @ViewChild('smartTable') smartTable!: StylesSmartTableComponent<any>;

  columnBuilder = new ListingHelper();

  constructor() {
    this.columnBuilder.addDefaultColumn('default');
    this.columnBuilder.addColumn('owner', ColumnTypes.Large);
    this.columnBuilder.addColumn('status', ColumnTypes.Large);
  }
}

class ColumnTypes {
  static readonly Small: ColumnType = new ColumnType(5, 9);
  static readonly Medium: ColumnType = new ColumnType(12, 20);
  static readonly Large: ColumnType = new ColumnType(15, 25);
}
